import { bindSwatchesClick, bindQuickAddSizeBtnClick, bindQuickAddMobileClick } from './quick-purchase.js';
import { runColorFilterOverlay, observeAjaxContent } from './product-filter-color.js';

document.addEventListener("DOMContentLoaded", function () {
    bindSwatchesClick(".shop__container");
    bindQuickAddSizeBtnClick(".shop__container");
    bindQuickAddMobileClick(".shop__container");
    runColorFilterOverlay();
});

// 监听hash变化
window.addEventListener('hashchange', function () {
    handleUrlChange("hashchange");
});

// 监听popstate事件
window.addEventListener('popstate', function () {
    handleUrlChange("popstate");
});

// 覆盖history API
const originalPushState = history.pushState;
history.pushState = function () {
    originalPushState.apply(history, arguments);
    handleUrlChange("history.pushState");
};

const originalReplaceState = history.replaceState;
history.replaceState = function () {
    originalReplaceState.apply(history, arguments);
    handleUrlChange("history.replaceState");
};

function handleUrlChange(type) {    
    // 执行你的URL变化处理逻辑
    if (type === 'history.pushState') {
        // 先隐藏图片
        document.querySelector("#ShopProducts").classList.add('selectedColor');
        const observer6 = observeAjaxContent('#ShopProducts', function (container, debouncedLogic, mutations) {
            debouncedLogic(mutations);
        });
    }
}